
  (function () {
    const mfKey = '__module_federation__containers';
    window[mfKey] = window[mfKey] || {};
    window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362'] = window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362'] || {
      get: async (cmpId) => {
        const importFn = window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362'][cmpId];
        const Component = await importFn();
        return () => Component;
      },
      init: async () => {
        
      },
    };

    window[mfKey]['bd59b79d-a12b-406d-914a-b85843e83362']['4757ec21-150c-4642-9565-bc774ac8fe41'] = () => import('/src/dashboard/pages/faqs/page.tsx');
  })();